"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.avro = require("etp-avro");
var schemas = require("./EtpSchemas.js");
var SchemaCache = (function (_super) {
    __extends(SchemaCache, _super);
    function SchemaCache(types) {
        if (types === void 0) { types = schemas.types; }
        var _this = _super.call(this, types) || this;
        _this.createProtocolMap();
        return _this;
    }
    SchemaCache.prototype.find = function (protocol, messageType) {
        // High-numbered messages are multi-protocol
        if (messageType >= 1000)
            protocol = 0;
        for (var schema in this) {
            if (this[schema].protocol == protocol && this[schema].messageType == messageType) {
                return this[schema];
            }
        }
        throw new Error("Schema for [" + protocol + ":" + messageType + "] not found.");
    };
    SchemaCache.prototype.createProtocolMap = function () {
    };
    return SchemaCache;
}(exports.avro.SchemaCache));
exports.SchemaCache = SchemaCache;
//# sourceMappingURL=Util.js.map